//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    animationData: {
      default: "",
    },
  },
  data() {
    return {
      editMode: false,
      newData: null,
      showJSON: false,
    };
  },
  computed: {
  },
  watch: {
    animationData() {
      this.newData = this.animationData
    },
  },
  methods: {
    save() {
      this.editMode = false;
      this.$emit("save", this.newData);
    },
  },
};
